import { Component, OnInit, ChangeDetectorRef } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from './helpers/authService.service'
import { Geolocation, PermissionStatus } from '@capacitor/geolocation'
import { Filesystem } from '@capacitor/filesystem' // To handle file permissions if needed
import axios from 'axios'
import { MenuController } from '@ionic/angular'
import { ThemeService } from './helpers/theme.service'
import { MySharedService } from './helpers/MySharedService'
import { httpConfig } from './helpers/httpConfig'

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  public selectedIndex = 0
  public ProfilePicture: any
  public ServiceUserName: any
  public ShowLogout: boolean = false
  public ShowAdminPage: boolean = false
  public isLoading: boolean = true // Loading state
  public logoImage: any

  public appPages = [
    {
      title: 'Home',
      url: '/default-page',
      icon: 'home',
    },
    {
      title: 'Assisted Service',
      url: '/assisted-service',
      icon: 'build',
    },
    {
      title: 'Profile',
      url: '/profilepage',
      icon: 'person',
    },
    {
      title: 'Search',
      url: '/searchpage',
      icon: 'search',
    },
    {
      title: 'About',
      url: '/aboutpage',
      icon: 'information-circle',
    },
    {
      title: 'FAQ',
      url: '/faqpage',
      icon: 'help',
    },
    {
      title: 'Contact Us',
      url: '/contact-page',
      icon: 'chatbubbles',
    },
  ]

  public showOutageMenu = false
  async checkSystemStatus() {
    // Add a small delay to ensure everything is initialized
    await new Promise((resolve) => setTimeout(resolve, 1000))

    let issueDetected = false
    let statusMessage = 'System Status (Outage)'

    // 1. Check Local API Health (Direct check to your database)
    try {
      const connUrl = this.myHTTPrequests.GetConnURL()
      if (!connUrl) throw new Error('Connection URL not found')

      // Try to fetch a small, harmless resource
      await axios.get(`${connUrl}getServiceList`, { timeout: 5000 })
    } catch (e: any) {
      // If the API returns a 500 or fails to connect, we know the DB is down for the user
      issueDetected = true
      statusMessage = 'Database Connectivity Issue'
      console.warn('System Status: Local API is offline.')
    }

    // 2. Check Supabase Global Status (Backup)
    if (!issueDetected) {
      try {
        const response = await axios.get(
          'https://status.supabase.com/api/v2/summary.json'
        )
        const status = response.data?.status?.indicator // 'none', 'minor', 'major', 'critical'
        if (status && status !== 'none') {
          issueDetected = true
          statusMessage = 'Supabase Global Issue'
        }
      } catch (e) {
        console.warn('System Status: Could not fetch Supabase status.')
      }
    }

    if (issueDetected) {
      try {
        this.showOutageMenu = true
        if (
          this.appPages &&
          !this.appPages.find((p) => p && p.title && p.title.includes('Status'))
        ) {
          this.appPages.unshift({
            title: statusMessage,
            url: 'https://status.supabase.com/',
            icon: 'warning',
          })
        }
        this.cdRef.detectChanges()
      } catch (err) {
        console.error('Error updating appPages with status:', err)
      }
    }
  }

  loginPage() {
    this.menuController.close('main-content')
    this.router.navigate(['/loged-in'], { replaceUrl: true })
  }

  constructor(
    private router: Router,
    private authService: AuthService,
    private cdRef: ChangeDetectorRef,
    private menuController: MenuController,
    public themeService: ThemeService,
    private myService: MySharedService,
    private myHTTPrequests: httpConfig
  ) {
    // this.requestPermissions()
    this.logoImage = this.myService.getLogoImage()
  }

  toggleTheme() {
    this.themeService.toggleTheme()
  }

  async requestPermissions() {
    try {
      // Request location permissions
      const geolocationPermission: PermissionStatus =
        await Geolocation.requestPermissions()
      if (geolocationPermission.location === 'granted') {
        // alert('Location permission granted')
        this.checkGpsStatus() // Check GPS status after permission is granted
      } else {
        alert('Location permission denied')
      }

      // Check Filesystem (if you need to access files)
      // You can handle any file system permission requests if needed.
    } catch (error) {
      console.error('Error requesting permissions', error)
    }
  }

  public signOut(): void {
    this.menuController.close('main-content')
    this.authService.logout()
  }

  public openExternal(url: string) {
    window.open(url, '_blank')
  }

  public adminPage(): void {
    this.menuController.close('main-content')
    this.authService.adminPage()
  }

  // Check if GPS is enabled
  async checkGpsStatus() {
    try {
      const coordinates = await Geolocation.getCurrentPosition()
      const { latitude, longitude } = coordinates.coords
    } catch (error) {
      console.error('Error fetching GPS data:', error)
      alert('Please enable GPS to use location services.')
    }
  }

  public Location: any
  public locationInfo: any = {}
  async geocodeLocation(latitude: number, longitude: number) {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
      )
      if (
        response.data &&
        response.data.address &&
        response.data.address.country
      ) {
        // console.log(response.data.address)
        this.locationInfo.country = response.data.address.country
        this.locationInfo.province = response.data.address.state
        this.locationInfo.suburb =
          response.data.address.city || response.data.address.suburb
        this.locationInfo.road = response.data.address.road

        this.Location =
          this.locationInfo.road +
          ', ' +
          this.locationInfo.suburb +
          ', ' +
          this.locationInfo.province

        // alert(`GPS is enabled: ${this.Location}`)
      } else {
      }
    } catch (error) {}
  }

  public borderColor: string = 'rgb(255, 255, 255)' // Default border color

  public ngOnInit(): void {
    this.checkSystemStatus()
    // Simulate loading time
    setTimeout(() => {
      this.isLoading = false
    }, 3000)

    this.getAuthStatus()

    // Check for automatic login/redirection
    setTimeout(() => {
      this.authService.autoLogin()
    }, 500) // Small delay to allow initial route to stabilize
  }

  getAuthStatus() {
    if (this.authService.isAuthenticated()) {
      this.ProfilePicture = this.authService.getProfilePicture()
      this.ServiceUserName = this.authService.getUsername()
      this.setBorderColor(this.authService.getSubscriptionType()) // Set the border color based on subscription type
      this.ShowLogout = true

      if (this.authService.getUserType() == 'Admin') {
        this.ShowAdminPage = true
      }
    }

    // this.requestPermissions()

    // Listen for profile picture changes
    this.authService.profilePictureChanged.subscribe((profilePicture) => {
      this.ProfilePicture = profilePicture
      this.cdRef.detectChanges() // Trigger change detection manually
    })

    this.authService.profileSubscriptionChanged.subscribe(
      (subscriptionType) => {
        this.setBorderColor(subscriptionType)
        this.cdRef.detectChanges() // Trigger change detection manually
      }
    )

    this.authService.logoutChange.subscribe((logoutStatus) => {
      this.ShowLogout = logoutStatus == 'true' ? true : false
      // Only show admin page if logged in AND user type is Admin
      if (logoutStatus == 'true' && this.authService.getUserType() == 'Admin') {
        this.ShowAdminPage = true
      } else {
        this.ShowAdminPage = false
      }
      this.cdRef.detectChanges() // Trigger change detection manually
    })
  }

  private setBorderColor(subscriptionType: any): void {
    // console.log('subscriptionType: ', subscriptionType)
    switch (subscriptionType) {
      case 'Premium':
        this.borderColor = '#5c5c5c' // Platinum color
        break
      case 'Gold':
        this.borderColor = '#d5bc00' // Gold color
        break
      case 'Silver':
        this.borderColor = '#C0C0C0' // Silver color
        break
      default:
        this.borderColor = 'rgb(255, 255, 255)' // Default color
        break
    }
  }
}
